export default {
  QUESTION: 'question',
  ANSWER: 'answer',
  VIDEO: 'video',
  DOCUMENT: 'document',
  ASSET: 'asset',
  FOLDER: 'folder',
  SERIES: 'series',
  INDEPENDENT_MODULE: 'independentModule',
  COURSES: 'courses',
  CAMPAIGN: 'campaign',
  EPISODE: 'episode',
  PUZZLE: 'puzzle',
  ASSESSMENT: 'assessment',
  TEXT_BLOCK: 'textBlock',
  MODULE: 'embeddedModule',
  CLOUDINARY: 'cloudinaryVideo',
  EMAIL_NOTIFICATION: 'emailNotification',
  SLACK_NOTIFICATION: 'slackNotification',
  MS_TEAMS_NOTIFICATION: 'msTeamsNotification',
  CHAT_NOTIFICATION: 'chatNotification',
  CONTENT_IMAGES: 'contentImages',
};
